import { UserRole } from 'enums';
import { nationIcon } from 'constants/images';

export const directOptions = [
  {
    label: 'Direct',
    value: 'DIRECT'
  },
  {
    label: 'Indirect',
    value: 'INDIRECT'
  }
];

export const tbmTaskLevelOptions = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'General',
    value: 'GENERAL'
  },
  {
    label: 'High Risk',
    value: 'HIGH_RISK'
  }
];

export const tbmStatusOptions = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'Working',
    value: 'WORKING'
  },
  {
    label: 'Complete',
    value: 'COMPLETE'
  }
];

export const noticeCategoryOptions = [
  {
    label: 'All',
    value: 'ALL'
  },
  // {
  //   label: 'Master',
  //   value: 'MASTER'
  // },
  {
    label: 'Important',
    value: 'IMPORTANT'
  },
  {
    label: 'General',
    value: 'GENERAL'
  }
];

export const createNoticeCategoryOptions = [
  {
    label: 'General Notice',
    value: 'GENERAL'
  },
  {
    label: 'Important Notice',
    value: 'IMPORTANT'
  }
];

/**
 * M-PTW Status Option
 */
export const statusOptions = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'Draft',
    value: 'Draft'
  },
  {
    label: 'Ongoing',
    value: 'Ongoing'
  },
  {
    label: 'Rejected',
    value: 'Denied'
  },
  {
    label: 'Approved',
    value: 'Approved'
  }
];

/**
 * M-PTW Status Option
 */
export const myApprovalStatusOptions = [
  {
    label: 'All',
    value: 'ALL'
  },
  {
    label: 'Before',
    value: 'Before'
  },
  {
    label: 'Complete',
    value: 'Complete'
  }
];

/**
 * Login, Signup, User Blood Option
 */

export const bloodOptions = [
  {
    label: 'A-',
    value: 'A-'
  },
  {
    label: 'A+',
    value: 'A+'
  },
  {
    label: 'B-',
    value: 'B-'
  },
  {
    label: 'B+',
    value: 'B+'
  },
  {
    label: 'O-',
    value: 'O-'
  },
  {
    label: 'O+',
    value: 'O+'
  },
  {
    label: 'AB-',
    value: 'AB-'
  },
  {
    label: 'AB+',
    value: 'AB+'
  }
];

/**
 * User Info Role Option
 */

export const userOptions = [
  {
    label: 'ADMIN',
    value: 'ROLE_ADMIN'
  },
  {
    label: 'CLIENT',
    value: 'ROLE_CLIENT'
  },
  {
    label: 'EPC',
    value: 'ROLE_EPC'
  },
  {
    label: 'VENDOR',
    value: 'ROLE_VENDOR'
  },
  {
    label: 'WORKER',
    value: 'ROLE_WORKER'
  }
];

/**
 * User Client Info Role Option
 */

export const userSiteAdminOptions = [
  {
    label: 'Site Admin',
    value: UserRole.ROLE_SITE_ADMIN
  },
  {
    label: 'Contractor',
    value: UserRole.ROLE_CONSTRUCTOR
  },
  {
    label: 'Sub-Contractor',
    value: UserRole.ROLE_SUB_CONSTRUCTOR
  },
  {
    label: 'Worker',
    value: UserRole.ROLE_WORKER
  }
];

export const userAuthorityOptions = [
  {
    label: 'Site Admin',
    value: UserRole.ROLE_SITE_ADMIN
  },
  {
    label: 'Contractor',
    value: UserRole.ROLE_CONSTRUCTOR
  },
  {
    label: 'Sub-Contractor',
    value: UserRole.ROLE_SUB_CONSTRUCTOR
  }
];

export const workerAuthorityOptions = [
  {
    label: 'Worker',
    value: UserRole.ROLE_WORKER
  }
];

export const userMasterAdminOptions = [
  {
    label: 'Master Admin',
    value: UserRole.ROLE_MASTER_ADMIN
  },
  ...userSiteAdminOptions
];

export const userContractorOptions = [
  ...userSiteAdminOptions.filter((option) => option.value !== UserRole.ROLE_SITE_ADMIN)
];

export const userSubContractorOptions = [
  ...userContractorOptions
    .filter((option) => option.value !== UserRole.ROLE_CONSTRUCTOR)
    .filter((option) => option.value !== UserRole.ROLE_SITE_ADMIN)
];

export const passportOptions = [
  {
    label: 'ALL',
    value: 'ALL'
  },
  {
    label: 'Assign',
    value: 'ASSIGN'
  },
  {
    label: 'YET',
    value: 'YET'
  }
];

export const companyTypeOptions = [
  {
    label: 'Client',
    value: 'CLIENT'
  },
  {
    label: 'Contractor',
    value: 'CONTRACTOR'
  },
  {
    label: 'Sub-Contractor',
    value: 'SUB_CONTRACTOR'
  }
];

export const newNationOptions = [
  {
    label: 'SAU +966',
    numberCode: '+966',
    value: '45b2cfec-1049-4ec0-9a53-8c6ac4f67550',
    icon: nationIcon.sau
  },
  {
    label: 'KOR +82',
    numberCode: '+82',
    value: '5b393101-42b1-437f-a9d8-379430a7cf79',
    icon: nationIcon.kor
  }
];

/**
 * ==============================================================================================
 * Fadhili Gas Increment Project
 * ==============================================================================================
 */
export const samsungPkgOptions = [
  {
    label: 'PKG#1',
    value: 'pkg1'
  },
  {
    label: 'PKG#4',
    value: 'pkg4'
  }
];

export const userWarningRecordOptions = [
  {
    label: '1st Warning',
    value: 'FIRST_WARNING'
  },
  {
    label: '2nd Warning',
    value: 'SECOND_WARNING'
  },
  {
    label: 'Final Warning',
    value: 'FINAL_WARNING'
  },
  {
    label: 'Termination',
    value: 'TERMINATION'
  }
];

export const userStatusOptions = [
  {
    label: 'Using',
    value: 'USING'
  },
  {
    label: 'Lock',
    value: 'LOCK'
  }
];

export const userDateFilterOptions = [
  {
    label: 'ALL',
    value: 'ALL'
  },
  {
    label: 'Last Entry Date',
    value: 'LAST_ENTRY_DATE'
  },
  {
    label: 'Iqama Expiry Date',
    value: 'IQAMA_EXPIRY_DATE'
  },
  {
    label: 'Passport Expiry Date',
    value: 'PASSPORT_EXPIRY_DATE'
  },
  {
    label: 'Gatepass Expiry Date',
    value: 'GATEPASSPORT_EXPIRY_DATE'
  }
];
